import React from 'react'
import LicenseLookup from './components/LicenseLookup'
import { LicenseLookupProvider } from './contexts/LicenseLookupContext'

import './styles/license-lookup.css'
import { ToastContainer } from 'react-toastify'

type Props = {
    defaultSerial: string
}


export default function app({ defaultSerial }: Props) {
  return (
    <LicenseLookupProvider>
      <LicenseLookup defaultSerial={defaultSerial} />
      <ToastContainer />
    </LicenseLookupProvider>
  )
}